import axios from "axios";
import { TOKEN_USER, TOKEN_USER_ORI } from 'src/constants';

const APIURL = process.env.PUBLIC_URL + "/api";

axios.interceptors.request.use((config) => {
    config.headers = getHeaders(config.url);
    return config;
}, error => {
    return Promise.reject(error);
});


const getHeaders = () => {
  const token = localStorage.getItem(TOKEN_USER);
  const headers = {
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

const getWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;
    return axios.get(url, { params: body });
}
//
const get = (endpoint, filter = null) => {
    const url = `${APIURL}/` + endpoint;
    return axios.get(url);
}
//
const post = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, data);
}
const postBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, body, { params: param });
}
const postWithParam = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, null, { params: data });
}
//
const put = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.put(url, data);
}
const putBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.put(url, body, { params: param });
}
const putWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;

    return axios.put(url, null, { params: body });
}
//
const deleteWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;

    return axios.delete(url, { data: body });
}
const deleteBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.delete(url, body, { params: param });
}
export const commonService = {
    getWithParam,
    get,
    post,
    postWithParam,
    postBodyWithParam,
    put,
    putWithParam,
    putBodyWithParam,
    deleteWithParam,
    deleteBodyWithParam
};
